import React from 'react';
import { isMobileOnly } from 'react-device-detect';
import { Navbar } from 'components';
import NavStepper from './NavStepper';
import './LayoutWithStepper.scss';

const LayoutWithStepper = Wrapped => props => (
  <div className="app-wrapper app-wrapper--with-stepper">

    {!isMobileOnly && <Navbar {...props} />}
    <NavStepper {...props} />

    <main className="app-wrapper__content">
      <Wrapped {...props} />
    </main>
  </div>
);

export default LayoutWithStepper;
